import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MobileObserverService } from '@app-services/adaptive/mobile-observer.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

interface InfoColumn {
  id: string;
  width: string;
  header: string | null;
  cell: string | null;
  minWidth: string | null;
}

@Component({
  selector: 'app-skeleton-table',
  imports: [MatTableModule, NgxSkeletonLoaderModule],
  templateUrl: './skeleton-table.component.html',
  styleUrls: ['./skeleton-table.component.scss'],
})
export class SkeletonTableComponent implements OnInit, OnDestroy {
  @Input() countColumns = 0;
  private useMobileViewSubscription: Subscription;
  public useMobileView = false;
  dataSource = new MatTableDataSource<any>(new Array(12).fill({}));
  displayedColumns: string[] = [];
  columns: InfoColumn[] = [];
  headers: { [key: string]: string } = {
    '1': '30px',
    '4': '100px',
    '5': '100px',
    '6': '60px',
    '7': '60px',
    '8': '60px',
    '9': '60px',
  };
  widths: { [key: string]: string } = {
    '1': '3%',
    '2': '3%',
    '3': '3%',
    '4': '15%',
    '5': 'auto',
    '6': '20%',
    '7': '10%',
    '8': '10%',
    '9': '10%',
    '10': '10%',
  };
  minWidths: { [key: string]: string } = {
    '5': '60px',
  };
  cells: { [key: string]: string } = {
    '1': '30px',
    '2': '30px',
    '3': '30px',
  };

  constructor(private mobileObserverService: MobileObserverService) {}

  ngOnInit(): void {
    this.useMobileViewSubscription = this.mobileObserverService
      .mobileObserver()
      .subscribe(isMobile => (this.useMobileView = isMobile));

    this.columns = this.countColumns
      ? Array.from({ length: this.countColumns }, (_, index) =>
          this.setDataColumn(String(index + 1))
        )
      : ['1', '2', '3', '4', '5', '6', '7'].map(el => this.setDataColumn(el));

    this.displayedColumns = this.columns.map(el => el.id);
  }

  setDataColumn(index: string): InfoColumn {
    return {
      id: index,
      width: this.widths?.[index] ?? 'auto',
      header: this.headers?.[index] ?? null,
      cell: this.cells?.[index] ?? null,
      minWidth: this.minWidths?.[index] ?? null,
    };
  }

  ngOnDestroy(): void {
    this.useMobileViewSubscription?.unsubscribe();
  }
}
